import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Drawer, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { COLORS } from "../UserDashboard/dashboardConfig";

const useStyles = makeStyles((theme) => ({
  paper: { width: 460, maxWidth: "100vw", background: "#fafafa" },
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    background: "#fff",
    borderBottom: `1px solid ${COLORS.border}`,
    flexShrink: 0,
  },
  title: { flex: 1, fontSize: 20, fontWeight: 800, color: COLORS.primaryDark },
  body: { flex: 1, overflowY: "auto", padding: theme.spacing(2) },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    background: "#fff",
    borderTop: `1px solid ${COLORS.border}`,
    flexShrink: 0,
  },
  card: {
    background: "#fff",
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
    marginBottom: theme.spacing(2),
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    width: "100%",
    padding: theme.spacing(1.25, 2),
    background: "transparent",
    border: "none",
    borderBottom: `2px solid ${COLORS.primary}`,
    cursor: "pointer",
    textAlign: "left",
    fontFamily: "inherit",
  },
  cardHeaderClosed: { borderBottomColor: "transparent" },
  cardTitle: { flex: 1, fontSize: 16, fontWeight: 800, color: COLORS.primary },
  count: {
    minWidth: 24,
    padding: "2px 8px",
    borderRadius: 12,
    background: COLORS.success,
    color: "#fff",
    fontSize: 13,
    fontWeight: 700,
    textAlign: "center",
  },
  arrow: { color: COLORS.primary, transition: "transform 0.2s" },
  arrowOpen: { transform: "rotate(180deg)" },
  cardBody: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.75),
    padding: theme.spacing(2),
  },
}));

// Zwijana sekcja panelu filtrów; `count` = liczba aktywnych filtrów w sekcji.
export const FilterCard = ({ title, count = 0, defaultOpen = true, children }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className={classes.card}>
      <button
        type="button"
        className={`${classes.cardHeader} ${open ? "" : classes.cardHeaderClosed}`}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span className={classes.cardTitle}>{title}</span>
        {count > 0 && <span className={classes.count}>{count}</span>}
        <ExpandMoreIcon
          className={`${classes.arrow} ${open ? classes.arrowOpen : ""}`}
          fontSize="small"
        />
      </button>
      {open && <div className={classes.cardBody}>{children}</div>}
    </section>
  );
};

// Liczy niepuste wartości (tablice - gdy mają elementy, "false"/"" nie liczą się).
export const countFilled = (...values) =>
  values.filter((v) => (Array.isArray(v) ? v.length > 0 : Boolean(v))).length;

/** Wysuwany z prawej panel filtrów. Zawartość (sekcje z polami) przekazuje strona. */
const FilterDrawer = ({
  open,
  onClose,
  onClear,
  activeCount,
  total,
  totalLabel = "Wyników",
  children,
}) => {
  const classes = useStyles();
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.paper }}
    >
      <div className={classes.header}>
        <div className={classes.title}>Filtry</div>
        <Button size="small" onClick={onClear} disabled={activeCount === 0}>
          Wyczyść wszystkie
        </Button>
        <IconButton size="small" onClick={onClose} aria-label="Zamknij filtry">
          <CloseIcon />
        </IconButton>
      </div>
      <div className={classes.body}>{children}</div>
      <div className={classes.footer}>
        <span style={{ color: COLORS.textMuted, fontSize: 14 }}>
          {totalLabel}: <strong style={{ color: "#212121" }}>{total}</strong>
        </span>
        <Button variant="contained" color="primary" onClick={onClose}>
          Pokaż wyniki
        </Button>
      </div>
    </Drawer>
  );
};

export default FilterDrawer;
